/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon16Solid = forwardRef('KonturInstallIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm1.309-6.575A1.374 1.374 0 0 0 8 6.625a1.375 1.375 0 1 0 .424 2.683l2.134 2.134a.625.625 0 1 0 .884-.884L9.309 8.425ZM7.842 4.003a.5.5 0 1 1-.04-1 5.058 5.058 0 0 1 3.97 1.715 5.058 5.058 0 0 1 1.149 4.17.5.5 0 0 1-.984-.178 4.046 4.046 0 0 0-.92-3.336 4.046 4.046 0 0 0-3.175-1.37Z" })));
});
